import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onBookingClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'Inicio', id: 'hero' },
    { label: 'Vestidos', id: 'catalog' },
    { label: 'Accesorios', id: 'accessories' },
    { label: '¿Cómo alquilar?', id: 'how-it-works' },
    { label: 'Sedes', id: 'locations' },
    { label: 'Citas', id: 'appointments' },
    { label: 'Preguntas frecuentes', id: 'faq' },
    { label: 'Instagram', id: 'instagram' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-neutral-950/95 backdrop-blur-sm border-b border-neutral-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-20 lg:grid lg:grid-cols-[1fr_auto_1fr] lg:gap-4 xl:gap-10">
          {/* Mobile Menu Button (left) */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-white"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Desktop Navigation (left) */}
          <nav className="hidden lg:flex items-center gap-3 xl:gap-7 min-w-0 justify-start">
            {menuItems.slice(0, 4).map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-[11px] xl:text-sm text-neutral-300 hover:text-white transition-colors font-light tracking-wide whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Centered Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="absolute left-1/2 -translate-x-1/2 lg:static lg:translate-x-0 text-xl xl:text-2xl font-serif tracking-[0.25em] text-white hover:text-neutral-200 transition-colors whitespace-nowrap px-2"
          >
            MOREA
          </button>

          {/* Desktop Navigation (right) + CTA */}
          <div className="hidden lg:flex items-center gap-3 xl:gap-7 min-w-0 justify-end">
            {menuItems.slice(4).map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-[11px] xl:text-sm text-neutral-300 hover:text-white transition-colors font-light tracking-wide whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
            <Button
              onClick={onBookingClick}
              className="bg-white hover:bg-neutral-100 text-neutral-900 px-3 xl:px-6 py-2 xl:py-2.5 rounded-sm transition-all duration-300 hover:shadow-lg text-[11px] xl:text-sm whitespace-nowrap"
            >
              Agenda tu cita
            </Button>
          </div>

          {/* Mobile spacer to balance flex */}
          <div className="lg:hidden w-10" />
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-6 border-t border-neutral-800 animate-in slide-in-from-top-2 duration-200">
            <nav className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-neutral-300 hover:text-white transition-colors py-2 font-light tracking-wide"
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={() => {
                  onBookingClick();
                  setIsMenuOpen(false);
                }}
                className="bg-white hover:bg-neutral-100 text-neutral-900 w-full mt-4 rounded-sm transition-all duration-300"
              >
                Agenda tu cita
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
